<template>
  <v-card flat class="pa-0 ma-0">
    <v-card-text class="pt-4 ma-0">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Previlege</div>
        <div>
          <bread-crumb :bread-crumbs="['Previlege']" />
        </div>
      </v-card-title>
      <v-divider class="ma-0 pa-0"></v-divider>
      <v-form lazy-validation>
        <v-card class="mt-6 pb-6">
          <div class="d-flex">
            <v-sheet
              class="v-sheet--offset ms-4 pt-1 text-center"
              elevation="1"
              width="170px"
            >
              <p class="font-weight-bold">
                <v-icon small class="me-1">mdi-account-tie-outline</v-icon>
                Compilance
              </p>
            </v-sheet>
            <v-col
              class="v-sheet--offset ms-4 pt-1 text-center"
              elevation="1"
              width="170px"
            >
              <p class="font-weight-bold">
                <v-checkbox label=" Select All" v-model="compilance_switch" @click="selectModel(compilance_switch)"/>
              </p>
            </v-col>
          </div>
          <v-row class="ms-1 me-1 mt-2">
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Add Compilance Rule" v-model="compilance.add_comp_rule"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Get Compilance Rules"  v-model="compilance.get_comp_rule"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Add Compilance Limit"  v-model="compilance.add_comp_limit"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Add Person Limitations" v-model="compilance.add_per_limit"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Individual Risk" v-model="compilance.ind_risk"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Onboard Risk Table" v-model="compilance.onboard_risk"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Transaction Risk Table" v-model="compilance.transaction_risk"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Add Parameter" v-model="compilance.add_parameter"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Business Risk" v-model="compilance.bus_risk"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Field Setup" v-model="compilance.feild_setup"></v-switch>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="mt-6 pb-6" FLAT>
          <div class="d-flex">
            <v-sheet
              class="v-sheet--offset ms-4 pt-1 text-center"
              elevation="1"
              width="170px"
            >
              <p class="font-weight-bold">
                <v-icon small class="me-1">mdi-account-tie-outline</v-icon>
                Customers
              </p>
            </v-sheet>
            <v-col
              class="v-sheet--offset ms-4 pt-1 text-center"
              elevation="1"
              width="170px"
            >
              <p class="font-weight-bold">
                <v-checkbox label=" Select All" />
              </p>
            </v-col>
          </div>
          <v-row class="ms-1 me-1 mt-2" justify="space-between">
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="List of Customers"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Add Individual Customer"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Add Business Customer"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Push Customers"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Customer Profile"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Customer Authorization"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Beneficiary List"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Add Beneficiary"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Compilance Risk"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Compilance Limit"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Compilance Sanctions"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Transaction History"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Export"></v-switch>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="mt-6 pb-6">
          <div class="d-flex">
            <v-sheet
              class="v-sheet--offset ms-4 pt-1 text-center"
              elevation="1"
              width="170px"
            >
              <p class="font-weight-bold">
                <v-icon small class="me-1">mdi-account-tie-outline</v-icon>
                Transactons
              </p>
            </v-sheet>
            <v-col
              class="v-sheet--offset ms-4 pt-1 text-center"
              elevation="1"
              width="170px"
            >
              <p class="font-weight-bold">
                <v-checkbox label=" Select All" />
              </p>
            </v-col>
          </div>
          <v-row class="ms-1 me-1 mt-2">
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="List of Transactions"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Push Transactions"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Hold Transactions"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Export Transactions"></v-switch>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="mt-6 pb-6">
          <div class="d-flex">
            <v-sheet
              class="v-sheet--offset ms-4 pt-1 text-center"
              elevation="1"
              width="170px"
            >
              <p class="font-weight-bold">
                <v-icon small class="me-1">mdi-account-tie-outline</v-icon>
                Users
              </p>
            </v-sheet>
            <v-col
              class="v-sheet--offset ms-4 pt-1 text-center"
              elevation="1"
              width="170px"
            >
              <p class="font-weight-bold">
                <v-checkbox label=" Select All" />
              </p>
            </v-col>
          </div>
          <v-row class="ms-1 me-1 mt-2" >
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Partner User"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="List of Partners"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Admin User"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="List of Users"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Security"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Export"></v-switch>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="mt-6 pb-6">
          <div class="d-flex">
            <v-sheet
              class="v-sheet--offset ms-4 pt-1 text-center"
              elevation="1"
              width="170px"
            >
              <p class="font-weight-bold">
                <v-icon small class="me-1">mdi-account-tie-outline</v-icon>
                Roles
              </p>
            </v-sheet>
            <v-col
              class="v-sheet--offset ms-4 pt-1 text-center"
              elevation="1"
              width="170px"
            >
              <p class="font-weight-bold">
                <v-checkbox label=" Select All" />
              </p>
            </v-col>
          </div>
          <v-row class="ms-1 me-1 mt-2">
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Manage Roles"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Add New Role"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Previleges"></v-switch>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="mt-6 pb-6">
          <div class="d-flex">
            <v-sheet
              class="v-sheet--offset ms-4 pt-1 text-center"
              elevation="1"
              width="170px"
            >
              <p class="font-weight-bold">
                <v-icon small class="me-1">mdi-account-tie-outline</v-icon>
                Treasury
              </p>
            </v-sheet>
            <v-col
              class="v-sheet--offset ms-4 pt-1 text-center"
              elevation="1"
              width="170px"
            >
              <p class="font-weight-bold">
                <v-checkbox label=" Select All" />
              </p>
            </v-col>
          </div>
          <v-row class="ms-1 me-1 mt-2">
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Deals"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Settlement"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Funding"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Rates"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Business Rules"></v-switch>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="mt-6 pb-6">
          <div class="d-flex">
            <v-sheet
              class="v-sheet--offset ms-4 pt-1 text-center"
              elevation="1"
              width="170px"
            >
              <p class="font-weight-bold">
                <v-icon small class="me-1">mdi-account-tie-outline</v-icon>
                Developer Mode
              </p>
            </v-sheet>
            <v-col
              class="v-sheet--offset ms-4 pt-1 text-center"
              elevation="1"
              width="170px"
            >
              <p class="font-weight-bold">
                <v-checkbox label=" Select All" />
              </p>
            </v-col>
          </div>
          <v-row class="ms-1 me-1 mt-2">
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Modules of Roles"></v-switch>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="mt-6 pb-6">
          <div class="d-flex">
            <v-sheet
              class="v-sheet--offset ms-4 pt-1 text-center"
              elevation="1"
              width="170px"
            >
              <p class="font-weight-bold">
                <v-icon small class="me-1">mdi-account-tie-outline</v-icon>
                Logs
              </p>
            </v-sheet>
            <v-col
              class="v-sheet--offset ms-4 pt-1 text-center"
              elevation="1"
              width="170px"
            >
              <p class="font-weight-bold">
                <v-checkbox label=" Select All" />
              </p>
            </v-col>
          </div>
          <v-row class="ms-1 me-1 mt-2" justify="space-between">
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Locked Customers"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Locked Users"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Error"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="API"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Integration"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Customer Audit"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Login User"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Transaction"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Transaction Locked"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Transaction Modify "></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Transaction Audit"></v-switch>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="mt-6 pb-6">
          <div class="d-flex">
            <v-sheet
              class="v-sheet--offset ms-4 pt-1 text-center"
              elevation="1"
              width="170px"
            >
              <p class="font-weight-bold">
                <v-icon small class="me-1">mdi-account-tie-outline</v-icon>
                Settings
              </p>
            </v-sheet>
            <v-col
              class="v-sheet--offset ms-4 pt-1 text-center"
              elevation="1"
              width="170px"
            >
              <p class="font-weight-bold">
                <v-checkbox label=" Select All" />
              </p>
            </v-col>
          </div>
          <v-row class="ms-1 me-1 mt-2">
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Master Data"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Password Format"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Master Bank"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Payout Limit"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Jobs"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Tax Configuration"></v-switch>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="mt-6 pb-6">
          <div class="d-flex">
            <v-sheet
              class="v-sheet--offset ms-4 pt-1 text-center"
              elevation="1"
              width="170px"
            >
              <p class="font-weight-bold">
                <v-icon small class="me-1">mdi-account-tie-outline</v-icon>
                Country
              </p>
            </v-sheet>
            <v-col
              class="v-sheet--offset ms-4 pt-1 text-center"
              elevation="1"
              width="170px"
            >
              <p class="font-weight-bold">
                <v-checkbox label=" Select All" />
              </p>
            </v-col>
          </div>
          <v-row class="ms-1 me-1 mt-2">
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Country Setup"></v-switch>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="mt-6 pb-6">
          <div class="d-flex">
            <v-sheet
              class="v-sheet--offset ms-4 pt-1 text-center"
              elevation="1"
              width="170px"
            >
              <p class="font-weight-bold">
                <v-icon small class="me-1">mdi-account-tie-outline</v-icon>
                Partner
              </p>
            </v-sheet>
            <v-col
              class="v-sheet--offset ms-4 pt-1 text-center"
              elevation="1"
              width="170px"
            >
              <p class="font-weight-bold">
                <v-checkbox label=" Select All" />
              </p>
            </v-col>
          </div>
          <v-row class="ms-1 me-1 mt-2">
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Create Partner"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Partner Summary"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Add Agent"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Add Branch"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Partner Bank Mapping"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Master Bank / Branch Setup"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Supportive Bank"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Payee Route"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Partner Route"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Payout Partner Bank Summary"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Deposit Channel"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Manage Collection Point"></v-switch>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="mt-6 pb-6">
          <div class="d-flex">
            <v-sheet
              class="v-sheet--offset ms-4 pt-1 text-center"
              elevation="1"
              width="170px"
            >
              <p class="font-weight-bold">
                <v-icon small class="me-1">mdi-account-tie-outline</v-icon>
                Black List
              </p>
            </v-sheet>
            <v-col
              class="v-sheet--offset ms-4 pt-1 text-center"
              elevation="1"
              width="170px"
            >
              <p class="font-weight-bold">
                <v-checkbox label=" Select All" />
              </p>
            </v-col>
          </div>
          <v-row class="ms-1 me-1 mt-2">
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Sanction List"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Sanction Search"></v-switch>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch inset dense label="Mannual Compilance Setup "></v-switch>
            </v-col>
          </v-row>
        </v-card>
      </v-form>
    </v-card-text>
    <v-divider class="mb-0 pa-0"></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn depressed 
        color="primary"
        width="200px"
        height="40px"
        class="me-5"
        small
        @click="onClickNext()"
      >
        Save
      </v-btn>
    </v-card-actions>
    <OverlayPageVue :showOverlay="loader" />
  </v-card>
</template>

<script>
import OverlayPageVue from "@/utils/OverlayPage.vue";
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import alerts from "@/mixins/alerts";
export default {
  mixins: [alerts],
  name: "Previlege",
  data() {
    return {
      // expanded: [],
      loader: false,
      compilance_switch:false,
      compilance : {
        add_comp_rule:false,
        get_comp_rule:false,
        add_comp_limit:false,
        add_per_limit:false,
        ind_risk:false,
        onboard_risk:false,
        transaction_risk:false,
        add_parameter:false,
        bus_risk:false,
        feild_setup:false
      }
    };
  },
  components: {
    BreadCrumb,
    OverlayPageVue,
  },
  mounted() {},
  computed: {},
  methods: {
    stoploader() {
      setTimeout(() => {
        this.loader = false;
      }, 400);
    },

    selectModel(item){
      if(item==true){
        const compliance = this.compilance
        for (const key in compliance) {
         compliance[key] = true;
        }
      } else {
        const compliance = this.compilance
        for (const key in compliance) {
         compliance[key] = false;
        }
      }
      
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";
.width-anchor {
  width: 200px !important;
}

.required:after {
  content: " *";
  color: red;
}
.danger {
  color: rgb(255 155 155);
  transition: 1s;
}
.v-sheet--offset {
  top: -14px;
  width: 200px;
  height: 30px;
  position: relative;
  border-radius: 5px;
}
.v-sheet--offset1 {
  top: -20px;
  position: relative;
  border-radius: 10px;
  background-color: rgb(131, 24, 24) !important;
}
.outlined {
  border-radius: 7px;
  border: 1px solid gray;
}
.v-radio.v-label {
  margin-bottom: 0px !important;
}
.v-input--selection-controls .v-radio > .v-label {
  margin: auto !important;
}
.v-input--selection-controls__input + .v-label {
  margin: auto !important;
}

.v-input--selection-controls {
  margin-top: 0px;
  padding-top: 0px;
}
</style>
